export default {
  getTarget: function(link) {
    const parts = link.split('/')
    if (
      link.length > 0 &&
      link.substring(0, 1) == '/' &&
      (link.length == 1 || link.substring(0, 2) !== '//')
    ) {
      return '_self'
    }
    if (parts.length > 2 && parts[2] != document.location.host) {
      return '_blank'
    }
    return '_self'
  }
}
